import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';


import { Sighting } from '@spotter/models/sighting';
import { Absence } from '@spotter/models/absence';
import { Profile } from '@spotter/models/profile';


@Injectable({ providedIn: 'root' })
export class EventService {

    // Responses from HTTP requests
    fail401: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // Not logged in
    fail403: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // Logged in but not authorised
	fail404: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // Not found
    fail429: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // Too many requests
    fail419: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // CSRF presumably

    fail500: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // Server error
    fail503: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // Server in maintanence mode

    noInternet: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();   // No Internet
    
	//fail503: EventEmitter<any> = new EventEmitter<any>();
	//tokenError: EventEmitter<any> = new EventEmitter<any>();

    // Custom events
    authFailure: EventEmitter<any> = new EventEmitter<any>();
    tokenLoaded: EventEmitter<string> = new EventEmitter<string>;

    //avatarChanged: EventEmitter<Profile> = new EventEmitter<Profile>;
    profileChanged: EventEmitter<Profile> = new EventEmitter<Profile>;
    
    //sightingsLoaded: EventEmitter<void> = new EventEmitter<void>;
    sightingChanged: EventEmitter<Sighting> = new EventEmitter<Sighting>;
    sightingCreated: EventEmitter<Sighting> = new EventEmitter<Sighting>;
    sightingDeleted: EventEmitter<void> = new EventEmitter<void>;
    

    absenceChanged: EventEmitter<Absence> = new EventEmitter<Absence>;
    absenceCreated: EventEmitter<Absence> = new EventEmitter<Absence>;
    absenceDeleted: EventEmitter<void> = new EventEmitter<void>;

    filterChanged: EventEmitter<void> = new EventEmitter<void>;
    showFilter: EventEmitter<boolean> = new EventEmitter<boolean>;

    constructor(){};

}
